import React from 'react';
import csGroupPhoto from "../../assets/images/services/pages/customize-software/cs-group.png";
import {useTranslation} from "react-i18next";

const CustomSoftwareStudio = () => {
  const {t} = useTranslation();
  const lang = (key) => t(`customizedDevelopmentPage.${key}`);
  return (
    <div>
      {/* HERO */}
      <section
        id="hero"
        className="relative overflow-hidden pt-24 pb-28"
      >
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-32 -left-40 w-80 h-80 bg-indigo-500/20 blur-3xl rounded-full" />
          <div className="absolute top-40 -right-20 w-96 h-96 bg-cyan-500/20 blur-3xl rounded-full" />
        </div>

        <div className="md:w-theme-container w-mobile-container mx-auto relative grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <span className="inline-flex items-center rounded-full border border-indigo-500/40 bg-indigo-500/10 px-3 py-1 text-xs font-medium tracking-wide uppercase text-black">
              {lang('csStudio')}
            </span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight text-black">
              {lang('weDesign')}{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-cyan-400 to-emerald-300">
                 {lang('software')}
              </span>{" "}
              {lang('forTeam')}
            </h1>
            <p className="text-sm sm:text-base text-black max-w-xl">
              {lang('asATech')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="inline-flex justify-center items-center rounded-lg bg-theme-color px-5 py-3 text-sm font-medium text-white shadow-lg shadow-indigo-500/30 hover:bg-zinc-500 transition">
                {lang('bookAFreeCall')}
              </button>
              <button className="inline-flex justify-center items-center rounded-lg border border-slate-600 px-5 py-3 text-sm font-medium text-black hover:border-indigo-400 hover:text-slate-800 transition">
                {lang('exploreHow')}
              </button>
            </div>
            <div className="flex flex-wrap items-center gap-4 text-xs text-slate-800 pt-4 border-t border-slate-800">
              <span>{lang('webMobile')}</span>
              <span className="h-1 w-1 rounded-full bg-slate-600" />
              <span>{lang('weCanAccept')}</span>
            </div>
          </div>
          <div className="relative">
            <div className="relative aspect-[4/3] rounded-3xl bg-gradient-to-tr from-slate-900 via-slate-800 to-slate-900 border border-slate-700/70 overflow-hidden">
              <img
                src={csGroupPhoto}
                alt="Custom software dashboard"
                className="absolute inset-0 w-full h-full object-cover opacity-70 mix-blend-lighten"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900/40 to-transparent" />
              <div className="absolute top-4 left-4 text-[10px] bg-slate-900/80 px-3 py-2 text-white rounded-full border border-slate-700/60 hero-float">
                {lang('startFrom')}
              </div>
              <div className="absolute bottom-6 left-6 space-y-2 text-xs">
                <p className="text-slate-200/90">{lang('findingSolution')}</p>
                <div className="flex items-center gap-2 text-[10px] text-slate-400">
                  <span className="inline-flex px-2 py-1 rounded-full bg-slate-900/70 border border-slate-700/70">
                    {lang('aspxReact')}
                  </span>
                  <span className="inline-flex px-2 py-1 rounded-full bg-slate-900/70 border border-slate-700/70">
                    {lang('tailwindType')}
                  </span>
                </div>
              </div>
              <div className="absolute right-4 bottom-10 hero-float">
                <div className="rounded-xl bg-slate-900/80 border border-slate-700/60 px-3 py-2 text-[10px] text-slate-200 max-w-[9rem]">
                  <p>{lang('weAreReady')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CustomSoftwareStudio;
